export const home0bj0ne = {
  id: "pollice",
  lightBg: true,
  lightText: false,
  lightTextDesc: false,
  topline: "Premium Information",
  headLine: "What is Pollice?",
  description:
    "A pollice is a blockchain based E-Voting or Plebiscite     platform where any school/college or an organization can host  elections for their community.Here you can create your own election and allows your commmunity to vote for your favourite candidates. ",
  buttonLabel: "Learn more",
  imgStart: true,
  img: require("../../images/voting.svg"),
  alt: "pollice",
  dark: false,
  primary: false,
  darkText: true,
};

export const home0bjTwo = {
  id: "about",
  lightBg: false,
  lightText: true,
  lightTextDesc: true,
  topline: "Premium information",
  headLine: "What is Blockchain?",
  description:
    " A blockchain is a distributed database that is shared among the nodes of a computer network. As a database, a blockchain stores information electronically in digital format. Blockchains are best known for their crucial role in cryptocurrency systems, such as Bitcoin, for maintaining a secure and decentralized record of transactions. ",
  buttonLabel: "Get started",
  imgStart: true,
  img: require("../../images/blockchain.svg"),
  alt: "blockchain",
  dark: true,
  primary: true,
  darkText: false,
};

export const home0bjThree = {
  id: "metamask",
  lightBg: true,
  lightText: false,
  lightTextDesc: false,
  topline: "Premium NFT",
  headLine: "What is Metamask?",
  description:
    "MetaMask is a browser plugin that serves as an Ethereum wallet.Users can store Ether and other ERC-20 tokens in the MetaMask wallet.The wallet can also be used to interact with decentralized applications, or dapps.It also provides users with an entry point into the emerging world of decentralized finance.",
  buttonLabel: "Download Extension",
  imgStart: true,
  img: require("../../images/svg-2.svg"),
  alt: "metamask",
  dark: false,
  primary: false,
  darkText: true,
};
